export const BLOOMLIFE_SUPPORT_URL = "https://www.bloom-life.com/blood-glucose-contact"

export const BLOOD_GLUCOSE_DEVICE_NAME = "blood glucose monitor"
